/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pos-product-sales-report-container[_ngcontent-%COMP%]   #posproductsalesreport[_ngcontent-%COMP%]   .cursor-pointer[_ngcontent-%COMP%]{cursor:pointer}.pos-product-sales-report-container[_ngcontent-%COMP%]   #posproductsalesreport[_ngcontent-%COMP%]   .per-page-width[_ngcontent-%COMP%]{max-width:80px}.pos-product-sales-report-container[_ngcontent-%COMP%]   #posproductsalesreport[_ngcontent-%COMP%]   .icon-heart[_ngcontent-%COMP%]{font-size:32px;top:4px;position:relative}.pos-product-sales-report-container[_ngcontent-%COMP%]   #posproductsalesreport[_ngcontent-%COMP%]   .iconButtons[_ngcontent-%COMP%]:disabled{cursor:not-allowed!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/less/pos-product-sales-report.less.shim.ngstyle.js.pre-build-optimizer.js